export const hotTags = [
  "年度盛典红毯",
  "新剧开播",
  "演唱会门票",
  "综艺名场面",
  "城市夜经济",
  "社区暖心故事",
  "地铁通勤",
  "非遗手艺人",
  "宠物日常",
  "校园趣事",
  "秋冬穿搭",
  "文旅打卡",
  "科幻大片",
  "综艺翻车",
  "国潮品牌",
  "打工人日常",
];